import {
  InputNumber,
  Typography,
} from 'antd'
import React from 'react'

import s from './attribution-display.module.css'

const { Text } = Typography

export interface AttributionDisplayProps {
  type?: 'message' | 'post' | 'tips' | 'default'
  saleSetHours?: number
  saleSetMinutes?: number
  onSaleSetHoursChange?: (saleSetHours: number | null) => void
  onSaleSetMinutesChange?: (saleSetMinutes: number | null) => void
}

const messageSenderLabel = 'Sale is attributed to message sender'

export default function AttributionDisplay({
  type = 'default',
  saleSetHours,
  saleSetMinutes,
  onSaleSetHoursChange,
  onSaleSetMinutesChange,
}: AttributionDisplayProps) {
  const saleSetHoursElement = onSaleSetHoursChange ?
    <InputNumber min={0}
      onClick={(event) => event.stopPropagation()}
      controls={false}
      onChange={onSaleSetHoursChange}
      value={saleSetHours}
      className={s.Input}
    /> : saleSetHours
  const saleSetMinutesElement = onSaleSetMinutesChange
    ? <InputNumber min={0}
      onClick={(event) => event.stopPropagation()}
      controls={false}
      onChange={onSaleSetMinutesChange}
      value={saleSetMinutes} className={s.Input}
    /> : saleSetMinutes
  let display

  if (type === 'message') {
    display = (
      <div className={s.AttributionDisplay}>
        {messageSenderLabel}
      </div>
    )
  } else if (type === 'tips') {
    display = (
      <div className={s.AttributionDisplay}>
        Sale is attributed to the last Chatter who messaged the fan
        within {saleSetHoursElement} hours and {saleSetMinutesElement} minutes of the Creator being
        tipped.
        <div className={s.Warning}>
          <Text type="danger">*</Text>
          <Text type="secondary">
            If no Chatter messaged the fan within {saleSetHours} hours
            and {saleSetMinutes} minutes before they tipped, the sale will not be attributed to
            anyone.
          </Text>
        </div>
      </div>
    )
  } else if (type === 'post') {
    display = (
      <div className={s.AttributionDisplay}>
        {messageSenderLabel}
      </div>
    )
  }

  return display
}
